<template>
  <div class='on_board' v-loading.fullscreen.lock='up_loading' element-loading-text="Uploading...">
    <h1>{{msg_json.title}}</h1>
    <ol>
      <li v-for='(msg, index) of msg_json.list' :key="index">{{msg}}</li>
    </ol>
    <el-upload class="upload-demo" :action="action" :before-upload="beforeUpload" :on-success='upload_s_fn' :mul10ple='false' :show-file-list='false'>
      <inputUpload :init_width='init_width' :words='words'></inputUpload>
    </el-upload>
    <div class="self">
      <h1>{{msg_json.title_self}}</h1>
      <ol>
        <li v-for='(msg, index) of msg_json.list_self' :key="index">{{msg}}</li>
      </ol>
      <textarea name="" id="" v-model.trim='self_intor' cols="30" rows="10" placeholder='Write your self-introduction here *'></textarea>
      <p>
        <span :class='{red:self_br}'>{{self_nub}}</span>/1000</p>
    </div>
    <a class="save" :class="{cancel: !has_audio || self_intor === ''}" @click='submit'>Save</a>
    <div class="audio" v-if='audioSrc'>
      <audio :src="audioSrc" controls autoplay='autoplay'></audio>
      <div class="shadow" @click='offShadow()'></div>
    </div>
  </div>
</template>

<script>
import inputUpload from '@common/input_file.vue'
import basePath from '@api/basePath'

export default {
  data() {
    return {
      file: '',
      up_loading: false,
      msg_json: {
        title: '1. Upload introductory audio',
        list: [
          'This recording will be used for your students to get a better idea of who you are.',
          "You can use this recording to introduce yourself, where you're from, and share your teaching experience, hobbies, and interests.",
          'Please be sure that the recording is 30 seconds or less.'
        ],
        title_self: '2. Submit your self-introduction',
        list_self: [
          'The introduction will be translated to Chinese and will be visible to the students, so please be spontaneous. ',
          'You may include personal interests not included in the audio or other reasons why students should choose you as their teacher. ',
          'Limit is 1000 characters.'
        ]
      },
      init_width: '377',
      words: ' audio format / less than 10MB  ＊',
      has_audio: '',
      self_intor: '',
      self_intor2: '',
      self_nub: '0',
      self_br: false,
      self_y: false,
      audioSrc: ''
    }
  },
  components: {
    inputUpload
  },
  created() {
    this.$http.get('/Boarding/getTutor').then(d => {
      if (d.data.code == '75000') {
        if (d.data.res.info.audio) {
          this.words = d.data.res.info.audio
        }

        this.self_intor = d.data.res.info.desc || ''
      }
    })
  },
  methods: {
    beforeUpload(file) {
      const isDoc = file.type.indexOf('audio') > -1

      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isDoc) {
        this.$message.error('The file format is wrong.')
      }

      if (!isLt10M) {
        this.$message.error('The audio size should be less than 10MB.')
      }
      if (isDoc && isLt10M) {
        this.up_loading = true
      }

      return isDoc && isLt10M
    },
    upload_s_fn(response, file, fileList) {
      if (response.code == 75000) {
        this.$message.success('Congratulations, upload success!')
        this.up_loading = false
        this.file = response.res.url
        this.words = file.name
      } else {
        this.up_loading = false
        this.$message.error('Upload failed. Please try it again.')
      }
    },
    submit() {
      if (!this.has_audio || this.self_intor === '') return
      let params = new URLSearchParams()
      let _this = this
      this.file = this.file ? this.file : this.words
      if (!this.file) return
      if (!this.self_y) {
        this.$message.error('Please provide your self-introduction.')
        return
      }
      if (this.self_br) {
        this.$message.error(
          'The limit for your self-introduction is 1000 characters.'
        )
        return
      }
      let file_params = {
        audio: this.file,
        talk_desc: this.self_intor
      }
      for (let attr in file_params) {
        params.append(attr, file_params[attr])
      }
      this.self_intor2 = this.self_intor
      this.axios
        .post('/Boarding/upIntroductory', params)
        .then(function(response) {
          if (response && response.data.code == '75000') {
            _this.$message.success('save success.')
            _this.$router.replace('/personal_profile/sign_sa')
          } else {
            // 服务端错误
            _this.$message.error(response.data.message)
          }
        })
    },
    offShadow() {
      this.audioSrc = ''
    }
  },
  computed: {
    action() {
      return `${basePath}/Fileupload/uploadToHkOss`
    }
  },
  watch: {
    self_intor: {
      handler: function(o, n) {
        ;(this.self_nub =
          this.self_intor.length > this.self_nub
            ? this.self_intor.length
            : this.self_intor.length),
          (this.self_y = this.self_intor.length > 0 ? true : false)
      },
      deep: true
    },
    self_nub: {
      handler: function(o, n) {
        this.self_br = this.self_nub > 1000 ? true : false
      },
      deep: true
    },
    words: {
      handler: function(o, n) {
        this.has_audio = !this.words ? false : true
      },
      deep: true
    }
  }
}
</script>
<style>
.personal_profile .download {
  z-index: -1;
}
</style>
<style lang='less' scoped>
.on_board {
  .self {
    margin-top: 50px;
    textarea {
      width: 800px;
      height: 225px;
      line-height: 25px;
      font-size: 14px;
      padding: 10px;
      border-radius: 10px;
      color: #525252;
      outline: none;
      font-family: Arial;
      resize: none;
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #1e1e1e;
        opacity: 1;
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #1e1e1e;
        opacity: 1;
      }
      textarea:-ms-textarea-placeholder {
        color: #1e1e1e;
        opacity: 1;
      }
      textarea::-webkit-textarea-placeholder {
        color: #1e1e1e;
        opacity: 1;
      }
    }
    p {
      padding-top: 5px;
      font-size: 14px;
      color: #525252;
      .red {
        color: #fa1e01;
      }
    }
  }
  h1 {
    margin-top: 30px;
    font-size: 14px;
    font-weight: bold;
    color: #525252;
  }
  ol {
    padding: 20px 0 20px 0;
    li {
      list-style: disc;
      padding-bottom: 10px;
      color: #1e1e1e;
      margin-left: 18px;
      font-size: 14px;
    }
  }
  a.save {
    display: block;
    cursor: pointer;
    width: 337px;
    height: 46px;
    text-align: center;
    margin: 0 auto;
    margin-top: 80px;
    line-height: 46px;
    background: #ffc000;
    color: #010000;
    border-radius: 15px;
    &:hover {
      background: #fbd131;
    }
    &.cancel {
      background: #cccccc;
      color: #fff;
      cursor: default;
    }
  }
}
.audio {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.6;
    filter: alpha(opacity=60);
  }
  audio {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 2;
    width: 600px;
    transform: translate(-50%, -50%);
  }
}
</style>
 


// WEBPACK FOOTER //
// on_board.vue?5a7edba4